import APIClient from '@/shared/http/clients/api'

const resourceName = 'pld'
const APICore = process.env.APIBaseURLCore

const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)

const PldRepository = {
  Search
}

export default PldRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/pld.js